import { apiFetch, httpError } from '../services/apiFetch';

const API_URL = import.meta.env.VITE_API_URL;

// All endpoints mirror the API's JobAssignmentController. Manager+ only for
// the assign / unassign / by-job paths; Workers can only call
// fetchMyAssignments which returns their own assigned jobs.
export async function fetchAssignmentsByJob(jobId) {
    const res = await apiFetch(`${API_URL}/api/JobAssignment/GetByJob/${jobId}`, { method: 'GET' });
    if (!res.ok) throw await httpError(res, 'Failed to fetch assigned crew');
    return res.json();
}

export async function fetchMyAssignments() {
    const res = await apiFetch(`${API_URL}/api/JobAssignment/GetMyAssignments`, { method: 'GET' });
    if (!res.ok) throw await httpError(res, 'Failed to fetch your assignments');
    return res.json();
}

export async function assignToJob(jobId, userId) {
    const res = await apiFetch(`${API_URL}/api/JobAssignment/Assign`, {
        method: 'POST',
        body: JSON.stringify({ jobId, userId }),
    });
    if (!res.ok) throw await httpError(res, 'Failed to assign user');
    return res.json();
}

export async function unassign(assignmentId) {
    const res = await apiFetch(`${API_URL}/api/JobAssignment/Unassign/${assignmentId}`, {
        method: 'POST',
    });
    if (!res.ok) throw await httpError(res, 'Failed to unassign user');
    return true;
}
